export enum FeatureToggle {
  rtIppCaperBillingEnabled = 'rt_ipp_caper_billing_enabled',
}
